/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from 'react';
import ContentLoader from "react-content-loader";
import {SkeletonSettings} from "../../../../../atoms/effects/skeletons/utils/SkeletonSettings";

export const FavoriteRecipeRowSkeleton = (props) => (
    <ContentLoader
        width={"100%"}
        height={100}
        speed={SkeletonSettings.SPEED}
        backgroundColor={SkeletonSettings.BACKGROUND}
        foregroundColor={SkeletonSettings.FOREGROUND}
        style={{borderBottom: SkeletonSettings.BORDER}}
        {...props}>

        {/* Thumbnail image */}
        <rect x="0" y={`calc(50% - 40px)`} width="80" height="80"/>

        {/* Title */}
        <rect x="100" y={`calc(50% - 5px)`} rx="3" ry="3" width="15%" height="10"/>

        {/* Category 1 */}
        <rect x="45%" y={`calc(50% - 5px)`} rx="3" ry="3" width="10%" height="10"/>

        {/* Category 2 */}
        <rect x="60%" y={`calc(50% - 5px)`} rx="3" ry="3" width="10%" height="10"/>

        {/* Category 3 */}
        <rect x="75%" y={`calc(50% - 5px)`} rx="3" ry="3" width="10%" height="10"/>

        {/* Favorite button */}
        <circle cx="95%" cy="50%" r="24"/>

    </ContentLoader>
)
